export default __webpack_public_path__ + "c2c55cf719b98ae4c11d927086719bdf.svg";